/**
 * LiveCounter — compact status row. Intentionally NOT card-shaped so users
 * don't confuse it with a Vibe Tag. Two subtle lines:
 *   Line 1: ● LIVE · <status>  where status is
 *             - "You're the only one live right now." when live_count === 1
 *             - "N users live nearby"                when live_count >= 2
 *   Line 2: "N live vibes happening now · refreshes every breath" (unchanged)
 *
 * live_count is served by the backend based on ambient presence within scope
 * so this line updates automatically on the next feed poll / WS refresh —
 * no additional real-time plumbing needed.
 */
import { useTranslation } from "react-i18next";

export default function LiveCounter({ liveCount, vibesCount }) {
  const { t } = useTranslation();
  const statusText =
    liveCount === 1
      ? t("liveRoom.soloLive")
      : t("liveRoom.usersLive", { count: liveCount });
  return (
    <div className="mt-4 flex flex-col gap-0.5" data-testid="live-counter">
      <div className="flex items-center gap-2 text-xs font-mono-accent tracking-wider">
        <span className="inline-flex items-center gap-1.5 text-[#E60000]" aria-label="Live">
          <span className="w-1.5 h-1.5 rounded-full bg-[#E60000] shadow-[0_0_6px_rgba(230,0,0,0.9)]" />
          {t("liveRoom.live")}
        </span>
        <span className="text-zinc-500">·</span>
        <span
          className="text-zinc-400 normal-case tracking-normal"
          data-testid={liveCount === 1 ? "live-solo" : "live-count-line"}
          data-count={liveCount}
        >
          {statusText}
        </span>
      </div>
      <p className="text-zinc-600 text-[11px] pl-4">
        {t("liveRoom.vibesHappening", { count: vibesCount })}
      </p>
    </div>
  );
}
